document.addEventListener('DOMContentLoaded', function() {
  const videoPlayer = document.querySelector(
    '.videos-player-placeholder.new-player'
  );
  trackClick(videoPlayer, 'videoplayer_clicked');

  document.querySelectorAll('.videos-conversion-button').forEach(button => {
    let exerciseButton = button.closest('.js-exercise-conversion-button');
    let worksheetButton = button.closest('.js-worksheet-conversion-button');
    if (worksheetButton) trackClick(button, 'worksheetbutton_clicked');
    if (exerciseButton) trackClick(button, 'exercisebutton_clicked');
  });
});

function trackClick(element, eventName) {
  if (element && element.dataset.trackClick == 'true') {
    element.addEventListener('click', function() {
      // eslint-disable-next-line no-undef
      Sofatutor.trackGa4GeneralEvent(eventName);
    });
  }
}
